var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.currentComponent,_vm._b({tag:"component",on:{"on-change-component":_vm.onChangeComponent}},'component',{..._vm.$props, partner: _vm.partner, ..._vm.currentComponentParams},false))
}
var staticRenderFns = []

export { render, staticRenderFns }